const projectAmenities = [
  ['elevator', 'Thang máy', 'Elevator'], ['parking', 'Bãi giữ xe', 'Parking'],
  ['security', 'Bảo vệ', 'Security'], ['cctv', 'Camera an ninh', 'CCTV'],
  ['fingerprint', 'Khóa vân tay', 'Fingerprint access'], ['laundry', 'Máy giặt chung', 'Shared laundry'],
  ['drying', 'Sân phơi', 'Drying area'], ['ev_charging', 'Sạc xe điện', 'EV charging'],
  ['wifi', 'Wi-Fi', 'Wi-Fi'], ['fire_alarm', 'Báo cháy', 'Fire alarm'],
  ['fire_exit', 'Lối thoát hiểm', 'Emergency exit'], ['water_tank', 'Bồn nước dự phòng', 'Water storage'],
];
export default projectAmenities;
